import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

    //メインキーワード
    mainKeyword: '',
    //2ページ目のキーワード用配列
    secondKeyblocks: {
      topLeft: "",
      topCenter: "",
      topRight: "",
      middleLeft: "",
      middleCenter: "",
      middleRight: "",
      bottomLeft: "",
      bottomCenter: "",
      bottomRight: ""
    },

    //3階層目のキーワード用配列
    childKeyBlocks: {
      topLeftBlock: { topLeft: '', topCenter: '', topRight: '', middleLeft: '', middleCenter: '', middleRight: '', bottomLeft: '', bottomCenter: '', bottomRight: '' },

      topCenterBlock: { topLeft: '', topCenter: '', topRight: '', middleLeft: '', middleCenter: '', middleRight: '', bottomLeft: '', bottomCenter: '', bottomRight: '' },

      topRightBlock: { topLeft: '', topCenter: '', topRight: '', middleLeft: '', middleCenter: '', middleRight: '', bottomLeft: '', bottomCenter: '', bottomRight: '' },

      middleLeftBlock: { topLeft: '', topCenter: '', topRight: '', middleLeft: '', middleCenter: '', middleRight: '', bottomLeft: '', bottomCenter: '', bottomRight: '' },

      middleRightBlock: { topLeft: '', topCenter: '', topRight: '', middleLeft: '', middleCenter: '', middleRight: '', bottomLeft: '', bottomCenter: '', bottomRight: '' },

      bottomLeftBlock: { topLeft: '', topCenter: '', topRight: '', middleLeft: '', middleCenter: '', middleRight: '', bottomLeft: '', bottomCenter: '', bottomRight: '' },

      bottomCenterBlock: { topLeft: '', topCenter: '', topRight: '', middleLeft: '', middleCenter: '', middleRight: '', bottomLeft: '', bottomCenter: '', bottomRight: '' },

      bottomRightBlock: { topLeft: '', topCenter: '', topRight: '', middleLeft: '', middleCenter: '', middleRight: '', bottomLeft: '', bottomCenter: '', bottomRight: '' },
    },

  },
  mutations: {
    //メインキーワードに情報を追加
    setMainKeyword(state, text) {
      state.mainKeyword = text;
      state.secondKeyblocks.middleCenter = text;
    },
    //2ページ目キーワードに情報を追加
    setSecondKeyword(state, text) {
      //state.secondKeyblocks[index] = key;
      if (state.secondKeyblocks[text.index]) {
        state.secondKeyblocks[text.index] = text.keyblock;
      }

      //childKeyBlocksの各middleCenterにキーワードを設定
      const childKeyIndex = text.index + "Block";
      state.childKeyBlocks[childKeyIndex].middleCenter = text.keyblock;
    },
    //3階層目キーワードに情報を追加
    setChildKeyBlocks(state, text) {
      if (state.childKeyBlocks[text.index]) {
        state.childKeyBlocks[text.index][text.childIndex] = text.keyblock;
      }
    },
  },
  actions: {

  }

})
